import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SEVERITIES} from '../data/constants';

interface AlertState {
  alertOpen: boolean;
  alertMessage: string;
  alertSeverity: typeof SEVERITIES[keyof typeof SEVERITIES];
}

const initialState: AlertState = {
  alertOpen: false,
  alertMessage: '',
  alertSeverity: SEVERITIES.INFO,
};

const alertSlice = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    showAlert: (
      state,
      action: PayloadAction<{ message: string; severity: typeof SEVERITIES[keyof typeof SEVERITIES] }>
    ) => {
      state.alertOpen = true;
      state.alertMessage = action.payload.message;
      state.alertSeverity = action.payload.severity;
    },
    hideAlert: (state,
      action: PayloadAction<{ severity: typeof SEVERITIES[keyof typeof SEVERITIES]  }>
    ) => {
      state.alertOpen = false;
      state.alertMessage = '';
      state.alertSeverity = action.payload.severity;
    },
  },
});

export const { showAlert, hideAlert } = alertSlice.actions;

export default alertSlice.reducer;
